import { useEffect, useState } from "react";
import contacts from "../../RESTDATA";
import { calculateDistance, getRestCoords } from "./functions";

export default function useGeo(zont, isHighSeason, fullMenuFromParams) {
  const [currentPosition, setCurrentPosition] = useState({
    accuracy: null,
    distanceToRest: null,
  });
  const [isGeolocationAvailable, setIsGeolocationAvailable] = useState(false);

  const [radius, setRadius] = useState(contacts.radiuses.restSpot || 20);
  const [isInRest, setInRest] = useState(true);

  // useEffect(() => {
  //   if (fullMenuFromParams) {
  //     setInRest(true);
  //   }
  // }, [setInRest, fullMenuFromParams]);

  const updateGeolocation = () => {
    if (!contacts.useGeo) {
      setIsGeolocationAvailable(true);
      setCurrentPosition({ accuracy: 11, distanceToRest: 1 });
      return;
    }
    const [restSpot, rest] = getRestCoords(contacts);

    const options = {
      enableHighAccuracy: true,
    };

    new Promise((resolve, reject) => {
      navigator.geolocation.watchPosition(resolve, reject, options);
    })
      .then((successCallback) => {
        if (Object.keys(rest).length === 0 || !isHighSeason) {
          // If rest is empty, calculate distance for restSpot only
          const distanceToRest = calculateDistance(
            restSpot,
            successCallback.coords
          );

          setCurrentPosition({
            accuracy:
              successCallback.coords.accuracy > 50
                ? 33
                : successCallback.coords.accuracy,
            distanceToRest: distanceToRest,
          });
        } else {
          // If rest is not empty, calculate distance for each spot
          const distances = Object.entries(rest).map(([key, spot]) => {
            const distance = calculateDistance(spot, successCallback.coords);
            return { key, distance };
          });

          // Find the spot with the minimal distance
          const minDistanceSpot = distances.reduce(
            (min, curr) => (curr.distance < min.distance ? curr : min),
            distances[0]
          );

          setCurrentPosition({
            accuracy:
              successCallback.coords.accuracy > 50
                ? 33
                : successCallback.coords.accuracy,
            distanceToRest: minDistanceSpot.distance,
          });
          console.log("Nearest spot:", minDistanceSpot.key);
          if (minDistanceSpot.key !== "mainSpot" && !fullMenuFromParams) {
            setInRest(false);
          }
          // setRadius(contacts.radiuses[minDistanceSpot.key]);
        }

        setIsGeolocationAvailable(true);
      })
      .catch((error) => {
        console.log("Geolocation error:", error);
        setIsGeolocationAvailable(false);
      });
  };

  useEffect(() => {
    if (zont !== 0) {
      // Fetch geolocation on mount or when zont changes
      updateGeolocation();
    }
    // eslint-disable-next-line
  }, [zont]);

  return {
    currentPosition,
    isGeolocationAvailable,
    updateGeolocation,
    radius,
    setRadius,
    // isInRest,
  };
}
